import axiosInstance from "../../Hooks/http-server";
import { Envelope } from "./types";

// Lets the shared axios interceptor skip its global error toast for these
// requests: the Audience Layer pages show their own inline error and retry.
declare module "axios" {
  interface AxiosRequestConfig {
    skipGlobalToast?: boolean;
  }
}

/** Staging only for now: set in .env.dev, unset in every other build. */
export const AL_URL = process.env.REACT_APP_AL_URL ?? "";

export async function getStats<T>(path: string, query: string, signal: AbortSignal): Promise<Envelope<T>> {
  if (!AL_URL) throw new Error("REACT_APP_AL_URL is not set for this build");
  const res = await axiosInstance.get<Envelope<T>>(
    `${AL_URL}/admin/stats${path}${query ? `?${query}` : ""}`,
    { signal, skipGlobalToast: true },
  );
  return res.data;
}
